import { request2 } from "../request2";

export const getAllBids = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/bid',
		params
	})
}
